import { LanguageOption } from "types/external/swayam/assignment"

export const ASSIGNMENT_TABS = {
  QUESTION: "question",
  CODE_EDITOR: "code_editor",
  AI_HELPER: "ai_helper",
} as const

export const QUESTION_TYPE = {
  MCQ: "MCQ",
  NUMERIC: "NUMERIC_ANSWER",
  PROGRAMMING: "PROGRAMMING",
  MSQ: "MSQ",
} as const

export const QUESTION_TYPE_LABEL = {
  MCQ: "Multiple Choice Question",
  MSQ: "Multiple Select Question",
  NUMERIC: "Numeric Question",
  PROGRAMMING: "Programming Question",
} as const

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { label: "Text", value: "text" },
  { label: "Javascript", value: "javascript" },
  { label: "Python", value: "python" },
  { label: "Java", value: "java" },
  { label: "C++", value: "cpp" },
]
